import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../types/interfaces';
import { IBrokerAnalyticsUser } from '../../../types/broker';

export const trackFallbackModalOpen = (sc: IJsonQuery, user: IBrokerAnalyticsUser) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Show',
    label: 'BrokerDealPopUpFail',
    sc,
    page: {
      pageType: 'ListingJK',
      siteType: 'desktop',
      extra: {
        is_link: false,
      },
    },
    user,
    useLastProducts: true,
  });
};
